import { Button, Label } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';
import StatutMontantSimulation from '../../constants/simulation/statutMontantSimulation';
import type { StatutArbitrage } from '../../interfaces/simulation/arbitrageMasse';
import './ArbitrageMasseBarreActions.css';

interface ArbitrageMasseBarreActionsProps {
	loading: boolean;
	nombreSelectionnees: number;
	onArbitrer: (statut: StatutArbitrage) => void;
	onEffacerSelection: () => void;
	// null quand le total n'est pas connu
	totalDemandeFiltre: number | null;
	totalDemandeSelection: number | null;
}

// Barre affichee des la premiere ligne selectionnee
const ArbitrageMasseBarreActions = ({
	loading,
	nombreSelectionnees,
	onArbitrer,
	onEffacerSelection,
	totalDemandeFiltre,
	totalDemandeSelection,
}: ArbitrageMasseBarreActionsProps) => (
	<div
		className="arbitrageMasseBarreActions"
		data-testid="arbitrageMasseBarreActions"
	>
		<div className="arbitrageMasseBarreActionsDecompte">
			<Label
				circular
				color="blue"
				content={nombreSelectionnees}
				data-testid="arbitrageMasseNombreSelectionnees"
			/>
			<span>
				{`demande${nombreSelectionnees > 1 ? 's' : ''} sélectionnée${nombreSelectionnees > 1 ? 's' : ''}`}
				{totalDemandeSelection !== null &&
					` · ${formatMontant(totalDemandeSelection)}`}
			</span>
			{totalDemandeFiltre !== null && (
				<span
					className="arbitrageMasseBarreActionsTotalFiltre"
					data-testid="arbitrageMasseTotalDemandeFiltre"
				>
					{`Total demandé filtré : ${formatMontant(totalDemandeFiltre)}`}
				</span>
			)}
		</div>
		<div className="arbitrageMasseBarreActionsBoutons">
			<Button
				color="olive"
				content="Accepter"
				data-testid="arbitrageMasseAccepter"
				disabled={loading}
				icon="check"
				onClick={() => onArbitrer(StatutMontantSimulation.ACCEPTE)}
				size="small"
			/>
			<Button
				color="red"
				content="Refuser"
				data-testid="arbitrageMasseRefuser"
				disabled={loading}
				icon="times"
				onClick={() => onArbitrer(StatutMontantSimulation.REFUSE)}
				size="small"
			/>
			<Button
				color="teal"
				content="Remettre à arbitrer"
				data-testid="arbitrageMasseRemettreAArbitrer"
				disabled={loading}
				icon="undo"
				onClick={() => onArbitrer(StatutMontantSimulation.A_ARBITRER)}
				size="small"
			/>
			<Button
				basic
				content="Effacer la sélection"
				data-testid="arbitrageMasseEffacerSelection"
				disabled={loading}
				onClick={onEffacerSelection}
				size="small"
			/>
		</div>
	</div>
);

export default ArbitrageMasseBarreActions;
